export const capitalize = (string) =>
  string ? string.charAt(0).toUpperCase() + string.slice(1) : "";

export const joinWithCommasAnd = (array) => {
  if (array.length === 0) return "";
  if (array.length === 1) return array[0];
  if (array.length === 2) return array[0] + " and " + array[1];
  return array.slice(0, -1).join(", ") + ", and " + array[array.length - 1];
};

export const stringToBoolean = (stringValue) => {
  if (typeof stringValue === "boolean") return stringValue;
  switch (stringValue.toLowerCase().trim()) {
    case "true":
    case "yes":
    case "1":
      return true;

    case "false":
    case "no":
    case "0":
    case "":
    case null:
    case undefined:
      return false;

    default:
      return JSON.parse(stringValue);
  }
};
